import { categoryOptions, type CategoryOption } from './format';
import type { Category } from './types';

/** Expense/income categories in picker order. Transfer categories are never budgeted. */
export function budgetableOptions(categories: Category[]): CategoryOption[] {
  return categoryOptions(categories).filter((o) => o.kind !== 'transfer');
}

/** Rows currently on the budgets table, keeping picker order. */
export function visibleBudgetOptions(
  options: CategoryOption[],
  visibleIds: Iterable<number>,
): CategoryOption[] {
  const ids = new Set(visibleIds);
  return options.filter((o) => ids.has(o.id));
}

/** Copy for the delete-category confirm, including the Uncategorized warning. */
export function categoryDeleteWarning(label: string, transactionCount: number): string {
  if (transactionCount <= 0) {
    return `Remove "${label}"? This category will be deleted.`;
  }
  const noun = transactionCount === 1 ? 'transaction' : 'transactions';
  return `Remove "${label}"? ${transactionCount} ${noun} using this category will be switched to Uncategorized.`;
}

/** Active budgetable categories not yet on the table — candidates for Add. */
export function addableBudgetOptions(
  options: CategoryOption[],
  visibleIds: Iterable<number>,
): CategoryOption[] {
  const ids = new Set(visibleIds);
  return options.filter((o) => o.isActive && !ids.has(o.id));
}
